/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

import React, { Component } from "react";
import styled from "styled-components";
import NavBar from "../../components/NavBar";
import Theme from "../../utils/Theme";
import PropTypes from "prop-types";
import { Redirect, Route, Switch } from "react-router-dom";
import { connect } from "react-redux";
import { isBrowser } from "react-device-detect";
import { NoticeBar } from "antd-mobile";
import * as _ from "underscore";
import StallPage from "../StallPage";
import StallListingPage from "../StallListingPage";
import ProductPage from "../ProductPage";
import ReviewPage from "../ReviewPage";
import CartPage from "../CartPage";
import ScannerPage from "../ScannerPage";
import ProfilePage from "../ProfilePage";
import FavouritePage from "../FavouritePage";
import InviteFriendsPage from "../InviteFriendsPage";
import ProductSelectionPage from "../ProductSelectionPage";
import TopUpWalletPage from "../TopUpWalletPage";
import TopUpSuccessfulPage from "../TopUpSuccessfulPage";
import PaymentHistoryPage from "../PaymentHistoryPage";
import EditCartFoodPage from "../EditCartFoodPage";
import OrderSummaryPage from "../OrderSummaryPage";
import OrderPage from "../OrderPage";
import FoodQueuePage from "../FoodQueuePage";
import SearchPage from "../SearchPage";
import TermsAndConditionsPage from "../TermsAndConditionsPage";
import PointHistoryPage from "../PointHistoryPage";
import MyQrcodePage from "../MyQrcodePage";
import LinkedAccountPage from "../LinkedAccountPage";
import ProfileDetailsPage from "../ProfileDetailsPage";
import TabBar from "../../components/TabBar";
import NotificationModal from "../../components/NotificationModal";
import SelectionWarningModal from "../../components/SelectionWarningModal";
import ProfileUpdateModal from "../../components/ProfileUpdateModal";
import * as selectors from "../../selectors";
import * as globalSelectors from "../../selectors/global";
import * as userAction from "../../actions/user";
import * as globalAction from "../../actions/global";
import * as authAction from "../../actions/auth";
import * as notificationAction from "../../actions/notification";
import * as profileAction from "../../actions/profile";
import * as warningAction from "../../actions/warning";
import { FormattedMessage } from "react-intl";
import * as commonAction from "../../actions/common";
import * as bannerAction from "../../actions/banner";
import BannerModal from "../../components/BannerModal";

const StyledContainer = styled.div`
  max-width: ${Theme.MaxWidth}
  position: absolute;
  top: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #f4f4f4;
  text-align: center;
  height: 100%;
  width: 100%;
  overflow-x: hidden;
`;

const ContentContainer = styled.div`
  overflow-y: scroll;
  text-align: center;
  height: 100%;
  width: 100%;
  margin-top: ${props => (props.hasNavbar ? "4.1em" : "0em")};
  margin-bottom: 4.1em;
`;

class HomePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showNavbar: true,
      showTabbar: true,
      navbarTitle: null,
      navbarLeftIcon: null,
      navbarRightIcon: null,
      navbarLeftClick: null,
      navbarRightClick: null,
      showNotification: false,
      showReminder: false
    };
  }

  componentDidMount() {
    const { authToken } = this.props;

    if (authToken) {
      this.fetchUserCartItemData();
      this.fetchNotification();
      this.fetchProfileDetails();
      this.fetchCommonConfig();
    }

    this.fetchBannerData();

    this.notificationTimer = setInterval(() => {
      const { notificationData, authToken } = this.props;
      if (authToken && _.isEmpty(notificationData)) {
        this.fetchNotification();
      }
    }, 5000);
  }

  componentWillUnmount() {
    clearInterval(this.notificationTimer);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { pathname } = nextProps.history.location;
    const {
      updateTabbarPosition,
      updateNotificationItemsID,
      getProfileIsIncomplete,
      showBanner
    } = this.props;

    switch (pathname) {
      case "/shop/stall":
        updateTabbarPosition(0);
        break;
      case "/shop/cart":
        updateTabbarPosition(1);
        break;
      case "/shop/favourite":
        updateTabbarPosition(2);
        break;
      case "/shop/me":
        updateTabbarPosition(3);
        break;
    }

    if (nextProps.authToken !== this.props.authToken) {
      if (nextProps.authToken) {
        this.fetchUserCartItemData();
      }
    }

    if(showBanner !== nextProps.showBanner) {
      if(nextProps.showBanner === false) {
        if (nextProps.getProfileIsIncomplete) {
          if (pathname !== "/shop/profile/details") {
            this.showReminder(nextProps.getProfileIsIncomplete);
          }
        }
      }
    } else {
      if(nextProps.showBanner === false) {
        if (nextProps.getProfileIsIncomplete) {
          if (pathname !== "/shop/profile/details") {
            this.showReminder(nextProps.getProfileIsIncomplete);
          }
        }
      }
    }

    if (nextProps.notificationData !== this.props.notificationData) {
      if (!_.isEmpty(nextProps.notificationData)) {
        if (pathname === "/shop/queue") {
          updateNotificationItemsID && updateNotificationItemsID();
        } else {
          this.setState({ showNotification: true });
        }
      }
    }
  }

  onWarningOkayClicked = () => {
    const { updateWarningRequest } = this.props;

    updateWarningRequest && updateWarningRequest(false);
  };

  onOkayClicked = () => {
    const { history, updateNotificationItemsID } = this.props;

    /* Array put Api when in queue page */
    updateNotificationItemsID && updateNotificationItemsID();
    this.setState({ showNotification: false });
    history.push("/shop/queue");
  };

  onGotItClicked = id => {
    const { updateNotificationData } = this.props;

    /* Single Put Api */
    updateNotificationData && updateNotificationData(id);
  };

  showWarning = showWarningStatus => {
    const { getWarningRequest } = this.props;

    getWarningRequest && getWarningRequest(showWarningStatus);
  };

  onCancelProfile = () => {
    const { setProfileStatus } = this.props;
    setProfileStatus && setProfileStatus();
    this.setState({ showReminder: false });
  };

  onOkayProfile = () => {
    const { setProfileStatus, history } = this.props;
    setProfileStatus && setProfileStatus();
    this.setState({ showReminder: false });
    history.push("/shop/profile/details");
  };

  onCloseClicked = () => {
    const { dismissBanner } = this.props;
    dismissBanner && dismissBanner();
  };

  fetchCommonConfig = () => {
    const { getCommonConfigRequest } = this.props;
    getCommonConfigRequest && getCommonConfigRequest();
  };

  fetchProfileDetails = () => {
    const { getProfileBasic } = this.props;
    getProfileBasic && getProfileBasic();
  };

  fetchNotification = () => {
    const { getNotificationData } = this.props;

    getNotificationData && getNotificationData();
  };

  fetchUserCartItemData = () => {
    const { getUserCartItemRequest } = this.props;

    getUserCartItemRequest && getUserCartItemRequest();
  };

  fetchBannerData = () => {
    const { getBannerRequest } = this.props;

    getBannerRequest && getBannerRequest();
  };

  toggleNavbar = show => {
    this.setState({
      showNavbar: show
    });
  };

  toggleTabbar = show => {
    this.setState({
      showTabbar: show
    });
  };

  configNavbar = (
    navbarTitle = null,
    navbarLeftIcon = null,
    navbarRightIcon = null,
    navbarLeftClick = null,
    navbarRightClick = null
  ) => {
    this.setState({
      navbarTitle: navbarTitle,
      navbarLeftIcon: navbarLeftIcon,
      navbarRightIcon: navbarRightIcon,
      navbarLeftClick: navbarLeftClick,
      navbarRightClick: navbarRightClick
    });
  };

  getNavbar = () => {
    const {
      showNavbar,
      navbarTitle,
      navbarLeftIcon,
      navbarRightIcon,
      navbarLeftClick,
      navbarRightClick
    } = this.state;

    if (showNavbar) {
      return (
        <NavBar
          middleTitle={navbarTitle}
          leftIcon={navbarLeftIcon}
          rightIcon={navbarRightIcon}
          onLeftIconClick={navbarLeftClick}
          onRightIconClick={navbarRightClick}
          {...this.props}
        />
      );
    } else {
      return null;
    }
  };

  showReminder = profileIsIncomplete => {
    const { profileStatus } = this.props;
      this.setState({
        showReminder: profileStatus === "true" && profileIsIncomplete === true
      });
  };

  render() {
    const {
      showTabbar,
      showNavbar,
      showNotification,
      showReminder
    } = this.state;
    const {
      history,
      location,
      loading,
      userCartItemLength,
      orderIndicator,
      tabbarPosition,
      updateTabbarPosition,
      notificationData,
      displayWarning,
      warningStatus,
      bannerList,
      showBanner,
      bannerLoading,
    } = this.props;

    return (
      <StyledContainer>
        {this.getNavbar()}
        <ContentContainer hasTabbar={showTabbar} hasNavbar={showNavbar}>
          {isBrowser ? (
            <NoticeBar
              style={{ marginBottom: "5px" }}
              marqueeProps={{ loop: true, style: { padding: "0 7.5px" } }}
              mode="link"
              action={
                <span>
                  <FormattedMessage id="desktop.warning.action" />
                </span>
              }
              onClick={() => (window.location = "https://www.lssquare.com")}
            >
              <FormattedMessage id="desktop.warning.title" />
            </NoticeBar>
          ) : (
            false
          )}
          <Switch>
            <Route
              path="/shop/review/:id"
              render={props => (
                <ReviewPage
                  {...props}
                  showNavbar={this.toggleNavbar}
                  showTabbar={this.toggleTabbar}
                  navbarConfig={this.configNavbar}
                />
              )}
            />
            <Route
              path="/shop/product/:id"
              render={props => (
                <ProductPage
                  {...props}
                  showNavbar={this.toggleNavbar}
                  showTabbar={this.toggleTabbar}
                  navbarConfig={this.configNavbar}
                />
              )}
            />
            <Route
              path="/shop/selection/:id"
              render={props => (
                <ProductSelectionPage
                  {...props}
                  showNavbar={this.toggleNavbar}
                  showTabbar={this.toggleTabbar}
                  navbarConfig={this.configNavbar}
                />
              )}
            />
            <Route
              path="/shop/stall/:id"
              render={props => (
                <StallPage
                  {...props}
                  showNavbar={this.toggleNavbar}
                  showTabbar={this.toggleTabbar}
                  navbarConfig={this.configNavbar}
                />
              )}
            />
            <Route
              path="/shop/stall"
              render={props => (
                <StallListingPage
                  {...props}
                  showNavbar={this.toggleNavbar}
                  showTabbar={this.toggleTabbar}
                  navbarConfig={this.configNavbar}
                />
              )}
            />
            <Route
              path="/shop/cart/:id"
              render={props => (
                <EditCartFoodPage
                  {...props}
                  showNavbar={this.toggleNavbar}
                  showTabbar={this.toggleTabbar}
                  navbarConfig={this.configNavbar}
                />
              )}
            />
            <Route
              path="/shop/cart"
              render={props => (
                <CartPage
                  {...props}
                  showNavbar={this.toggleNavbar}
                  showTabbar={this.toggleTabbar}
                  navbarConfig={this.configNavbar}
                />
              )}
            />
            <Route
              path="/shop/order/:id"
              render={props => (
                <OrderSummaryPage
                  {...props}
                  showNavbar={this.toggleNavbar}
                  showTabbar={this.toggleTabbar}
                  navbarConfig={this.configNavbar}
                />
              )}
            />
            <Route
              path="/shop/order"
              render={props => (
                <OrderPage
                  {...props}
                  showNavbar={this.toggleNavbar}
                  showTabbar={this.toggleTabbar}
                  navbarConfig={this.configNavbar}
                />
              )}
            />
            <Route
              path="/shop/queue"
              render={props => (
                <FoodQueuePage
                  {...props}
                  showNavbar={this.toggleNavbar}
                  showTabbar={this.toggleTabbar}
                  navbarConfig={this.configNavbar}
                />
              )}
            />
            <Route
              path="/shop/favourite"
              render={props => (
                <FavouritePage
                  {...props}
                  showNavbar={this.toggleNavbar}
                  showTabbar={this.toggleTabbar}
                  navbarConfig={this.configNavbar}
                />
              )}
            />
            <Route
              path="/shop/me"
              render={props => (
                <ProfilePage
                  {...props}
                  showNavbar={this.toggleNavbar}
                  showTabbar={this.toggleTabbar}
                  navbarConfig={this.configNavbar}
                />
              )}
            />
            <Route
              path="/shop/scanner"
              render={props => (
                <ScannerPage
                  {...props}
                  showNavbar={this.toggleNavbar}
                  showTabbar={this.toggleTabbar}
                  navbarConfig={this.configNavbar}
                />
              )}
            />
            <Route
              path="/shop/self/qr-code"
              render={props => (
                <MyQrcodePage
                  {...props}
                  showNavbar={this.toggleNavbar}
                  showTabbar={this.toggleTabbar}
                  navbarConfig={this.configNavbar}
                />
              )}
            />
            <Route
              path="/shop/invite-friends"
              render={props => (
                <InviteFriendsPage
                  {...props}
                  showNavbar={this.toggleNavbar}
                  showTabbar={this.toggleTabbar}
                  navbarConfig={this.configNavbar}
                />
              )}
            />
            <Route
              path="/shop/terms-and-conditions"
              render={props => (
                <TermsAndConditionsPage
                  {...props}
                  showNavbar={this.toggleNavbar}
                  showTabbar={this.toggleTabbar}
                  navbarConfig={this.configNavbar}
                />
              )}
            />
            <Route
              path="/shop/top-up/successful"
              render={props => (
                <TopUpSuccessfulPage
                  {...props}
                  showNavbar={this.toggleNavbar}
                  showTabbar={this.toggleTabbar}
                  navbarConfig={this.configNavbar}
                />
              )}
            />
            <Route
              path="/shop/top-up"
              render={props => (
                <TopUpWalletPage
                  {...props}
                  showNavbar={this.toggleNavbar}
                  showTabbar={this.toggleTabbar}
                  navbarConfig={this.configNavbar}
                />
              )}
            />
            <Route
              path="/shop/payment/history"
              render={props => (
                <PaymentHistoryPage
                  {...props}
                  showNavbar={this.toggleNavbar}
                  showTabbar={this.toggleTabbar}
                  navbarConfig={this.configNavbar}
                />
              )}
            />
            <Route
              path="/shop/point/history"
              render={props => (
                <PointHistoryPage
                  {...props}
                  showNavbar={this.toggleNavbar}
                  showTabbar={this.toggleTabbar}
                  navbarConfig={this.configNavbar}
                />
              )}
            />
            <Route
              path="/shop/search"
              render={props => (
                <SearchPage
                  {...props}
                  showNavbar={this.toggleNavbar}
                  showTabbar={this.toggleTabbar}
                  navbarConfig={this.configNavbar}
                />
              )}
            />
            <Route
              path="/shop/profile/details"
              render={props => (
                <ProfileDetailsPage
                  {...props}
                  showNavbar={this.toggleNavbar}
                  showTabbar={this.toggleTabbar}
                  navbarConfig={this.configNavbar}
                />
              )}
            />
            <Route
              path="/shop/social"
              render={props => (
                <LinkedAccountPage
                  {...props}
                  showNavbar={this.toggleNavbar}
                  showTabbar={this.toggleTabbar}
                  navbarConfig={this.configNavbar}
                />
              )}
            />
            <Route
              exact
              path="/shop"
              render={() => <Redirect to="/shop/stall" />}
            />
            <Route render={() => <Redirect to="/not-found" />} />
          </Switch>
        </ContentContainer>
        <TabBar
          showWarning={this.showWarning}
          warningStatus={warningStatus}
          history={history}
          location={location}
          orderIndicator={orderIndicator}
          userCartItemLength={userCartItemLength}
          currentPosition={tabbarPosition}
          tabbarClicked={updateTabbarPosition}
        />
        <NotificationModal
          history={history}
          notificationData={notificationData}
          showNotification={showNotification}
          onGotItClicked={this.onGotItClicked}
          onOkayClicked={this.onOkayClicked}
          loading={loading}
        />
        <BannerModal
          history={history}
          bannerData={bannerList}
          showBanner={showBanner}
          onCloseClicked={this.onCloseClicked}
          loading={bannerLoading}
        />
        <SelectionWarningModal
          history={history}
          onWarningOkayClicked={this.onWarningOkayClicked}
          showWarning={displayWarning}
          status={warningStatus}
          loading={loading}
        />
        <ProfileUpdateModal
          history={history}
          showReminder={showReminder}
          onCancelProfile={this.onCancelProfile}
          onOkayProfile={this.onOkayProfile}
          loading={loading}
        />
      </StyledContainer>
    );
  }
}

HomePage.propTypes = {
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  authToken: PropTypes.string,
  isUserCartItemEmpty: PropTypes.bool,
  loading: PropTypes.bool,
  userCartItemLength: PropTypes.number,
  orderIndicator: PropTypes.bool,
  tabbarPosition: PropTypes.number,
  getUserCartItemRequest: PropTypes.func,
  updateTabbarPosition: PropTypes.func,
  getNotificationData: PropTypes.func,
  updateNotificationData: PropTypes.func,
  updateNotificationItemsID: PropTypes.func,
  getWarningRequest: PropTypes.func,
  updateWarningRequest: PropTypes.func,
  notificationData: PropTypes.array,
  notificationItemsID: PropTypes.array,
  getProfileBasic: PropTypes.func,
  getProfileIsIncomplete: PropTypes.bool,
  profileStatus: PropTypes.string,
  setProfileStatus: PropTypes.func,
  displayWarning: PropTypes.bool,
  warningStatus: PropTypes.bool,
  showBanner: PropTypes.bool,
  bannerLoading: PropTypes.bool,
  getCommonConfigRequest: PropTypes.func,
  getBannerRequest: PropTypes.func,
  dismissBanner: PropTypes.func,
};

function mapStateToProps(state) {
  return {
    authToken: selectors.getAuthToken(state),
    profileStatus: selectors.getProfileStatus(state),
    isUserCartItemEmpty: selectors.getIsUserCartItemEmpty(state),
    userCartItemLength: selectors.getUserCartItemLength(state),
    orderIndicator: selectors.getOrderIndicatorStatus(state),
    tabbarPosition: globalSelectors.getCurrentTabbarPosition(state.global),
    notificationData: selectors.getNotificationData(state),
    notificationItemsID: selectors.getNotificationItemsID(state),
    loading: selectors.getNotificationLoading(state),
    getProfileIsIncomplete: selectors.getProfileDetailsIsIncomplete(state),
    displayWarning: selectors.getWarning(state),
    warningStatus: selectors.getWarningStatus(state),
    bannerList: selectors.getBannerItemList(state),
    showBanner: selectors.getShowBanner(state),
    bannerLoading: selectors.getBannerLoading(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getUserCartItemRequest: () => dispatch(userAction.getUserCartItemRequest()),
    getProfileBasic: () => dispatch(profileAction.getProfileBasicRequest()),
    getCommonConfigRequest: () =>
      dispatch(commonAction.getCommonConfigRequest()),
    getWarningRequest: showWarning =>
      dispatch(warningAction.getWarningRequest(showWarning)),
    updateWarningRequest: showWarning =>
      dispatch(warningAction.updateWarningRequest(showWarning)),
    getNotificationData: () =>
      dispatch(notificationAction.getNotificationRequest()),
    updateNotificationData: id =>
      dispatch(notificationAction.updateNotificationRequest(id)),
    updateNotificationItemsID: () =>
      dispatch(notificationAction.updateNotificationItemsIDRequest()),
    updateTabbarPosition: position =>
      dispatch(globalAction.updateTabbarPosition(position)),
    setProfileStatus: status => dispatch(authAction.setProfileStatus(status)),
    getBannerRequest: () => dispatch(bannerAction.getBannerRequest()),
    dismissBanner: () => dispatch(bannerAction.dismissBannerRequest()),

  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HomePage);



// WEBPACK FOOTER //
// ./src/containers/MainPage/index.js